import { useFlag } from '@calendly/feature-check-react'
import { useLocation } from 'react-router-dom'

import {
  getOverviewHelpCenterLink,
  useContextualHelp,
} from 'features/contextual_help'
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events'

import { ANALYTICS_FLOW_STARTED_PROPS_MAP, EMPTY_STATE_ICON_MAP, EYEBROW_TEXT } from '../constants'
import { ActionButton } from './action_button'
import { LeftRightEmptyState } from './left_right_empty_state'

export const LeftRightEmptyStateContainer = ({
  contentKey,
  options,
  buttonOverride,
  featureKey = null,
  border = false,
  preview = false,
  hideLearnMore = false,
  hideActionButton = false
}) => {
  const iconImage = EMPTY_STATE_ICON_MAP[contentKey]
  const eyebrowText = EYEBROW_TEXT.includes(contentKey)
  const { pathname } = useLocation()
  const track = useTrack()
  const { open: openContextualHelp } = useContextualHelp()
  // Match right_rail/routes.js contextual_help useGuard — avoid unauthorized pane toast.
  const canOpenContextualHelp = useFlag('activation_q3')

  const onClickLearnMore = () => {
    if (canOpenContextualHelp) {
      openContextualHelp({ contentKey })
    } else {
      const helpCenterLink = getOverviewHelpCenterLink(contentKey)
      if (helpCenterLink) {
        window.open(helpCenterLink, '_blank', 'noopener,noreferrer')
      }
    }

    const properties = ANALYTICS_FLOW_STARTED_PROPS_MAP[contentKey]?.(pathname)
    if (!properties) return

    track({
      name: TRACKING_EVENT_NAMES.FLOW_STARTED,
      properties
    })
  }

  return (
    <LeftRightEmptyState
      contentKey={contentKey}
      iconImage={iconImage}
      eyebrowText={eyebrowText}
      border={border}
      preview={preview}
      hideLearnMore={hideLearnMore}
      onClickLearnMore={onClickLearnMore}
      actionButton={!hideActionButton && (
        <ActionButton button={buttonOverride} contentKey={contentKey} featureKey={featureKey} options={options} />
      )}
    />
  )
}
